exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-header[data-v-6228adae]{padding:0}.table-box[data-v-6228adae] .el-table th{background-color:#f7fbff}\n", ""]);

// exports
